/* eslint-disable no-unused-vars */
import { debounce } from '@/lib/utils';
import { ON_CHANGE_DEBOUNCE_TIMER } from './constants';

class SearchForm extends HTMLElement {
  protected input: HTMLInputElement | null;
  protected resetButton: HTMLElement | null;

  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form?.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event: Event) => {
          this.onChange(event);
        }, ON_CHANGE_DEBOUNCE_TIMER),
      );
    }
  }

  toggleResetButton(): void {
    if (!this.resetButton) return;

    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input && this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input && this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange(_event: Event): void {
    this.toggleResetButton();
  }

  shouldResetForm(): boolean {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event: Event): void {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      if (this.input) {
        this.input.value = '';
        this.input.focus();
        this.toggleResetButton();
      }
    }
  }
}

customElements.define('search-form', SearchForm);

export default SearchForm;
